import { render } from "./desktop-header.vue?vue&type=template&id=76f3c4c7&scoped=true"
import script from "./desktop-header.vue?vue&type=script&lang=js"
export * from "./desktop-header.vue?vue&type=script&lang=js"

import "../../../assets/css/desktop.css?vue&type=style&index=0&id=76f3c4c7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76f3c4c7"

export default script